<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="projects"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:[`item.testUrl`]="{ item }">
        <template v-for="(link, i) in item.testUrl">
          <a :href="link.url" :key="i">{{ link.url }}</a>
          ({{ link.note }})
        </template>
      </template>
      <template v-slot:[`item.realUrl`]="{ item }">
        <template v-for="(link, i) in item.realUrl">
          <a :href="link.url" :key="i">{{ link.url }}</a>
          ({{ link.note }})
        </template>
      </template>
      <template v-slot:[`item.empNms`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="d-inline-block text-truncate"
              style="max-width:200px;vertical-align:middle;"
              >{{ item.empNms }}</span
            >
          </template>
          <span>{{ item.empNms }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          :to="`/project/write/${item.prjNo}`"
          small
          class="mr-2"
          title="수정"
        >
          mdi-pencil
        </v-icon>
        <v-icon small @click="onRemoveProject(item)" title="삭제">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { delPrj, listPrj } from "@/api/project";
export default {
  data() {
    return {
      headers: [
        {
          text: "연도",
          value: "prjStYy",
          width: "8%",
        },
        {
          text: "프로젝트명",
          value: "prjNm",
          width: "15%",
        },
        {
          text: "테스트서버 URL",
          value: "testUrl",
          width: "17%",
          sortable: false,
        },
        {
          text: "실서버 URL",
          value: "realUrl",
          width: "17%",
          sortable: false,
        },
        {
          text: "비고",
          value: "note",
          width: "25%",
          sortable: false,
        },
        {
          text: "참여 직원",
          value: "empNms",
          width: "10%",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          width: "8%",
          align: "center",
          sortable: false,
        },
      ],
      snackbar: {
        show: false,
        message: "",
      },
      projects: [],
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    showAlert(msg) {
      this.snackbar.show = true;
      this.snackbar.message = msg;
    },
    async loadList() {
      try {
        const { data } = await listPrj();
        const list = data.list.map(v => {
          let names = [];

          // 참여직원
          const empList = v.empList.map(v => {
            names.push(v.empNm);

            const newList = {
              empNo: v.empNo,
              empNm: v.empNm,
            };

            return newList;
          });

          names = names.join(", ");

          // url - 추후 수정
          let testUrl = v.testUrlList
            ? v.testUrlList.map(i => ({ note: i.note, url: i.url }))
            : [];

          let realUrl = v.realUrlList
            ? v.realUrlList.map(i => ({ note: i.note, url: i.url }))
            : [];

          const newData = {
            ...v,
            prjAgncNm: !v.prjAgncNm ? "" : v.prjAgncNm,
            prjSt: !v.prjSt ? "" : v.prjSt,
            prjStCd: !v.prjStCd ? 200 : v.prjStCd,
            empList,
            testUrl,
            realUrl,
            empNms: v.empList.length ? names : "",
          };

          return newData;
        });

        this.projects = list;
      } catch (error) {
        console.log(error);
      }
    },
    async onRemoveProject(item) {
      try {
        const { prjNo } = item;
        const { data } = await delPrj(prjNo);

        if (data.ret === 1) {
          this.showAlert("삭제되었습니다.");
          this.loadList();
        } else {
          this.showAlert("삭제 실패.");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #f3f8fb !important;
}
</style>
